import { GraphQLFieldConfig } from 'graphql'
import { Context } from '../shared'
import { stigTemplateDetail, StigTemplateDetail } from '../types/stig-template'
import {
  applicationQueryArgs,
  ApplicationQueryArgs
} from '../types/application-query-args'

export const stigTemplate: GraphQLFieldConfig<
  any,
  Context,
  ApplicationQueryArgs
> = {
  description:
    'Get details of an uploaded STIG template for a specific application',
  type: stigTemplateDetail,
  args: applicationQueryArgs,
  async resolve(_source, args, context): Promise<StigTemplateDetail> {
    const { organizationID, applicationID } = args

    const { name, created } = await context.connector.get(
      `/${organizationID}/applications/${applicationID}/stig`
    )

    return {
      name,
      created
    }
  }
}
